<script setup lang="ts">
import { Phone, LightbulbIcon, PlayIcon } from 'lucide-vue-next';
import FormSection from './FormSection.vue'
import { useI18n } from 'vue-i18n'

const { tm } = useI18n()
const steps = tm('contactSection.steps') as any[]
</script>

<template>
  <section id="contact" class="py-32 bg-gradient-to-br from-indigo-50 to-white">
    <div class="container mx-auto px-4">
      <div class="grid md:grid-cols-2 gap-6">

        <div class="flex justify-center">
          <div class="space-y-12">
            <!-- Step 1 -->
            <div class="max-w-[300px] relative">
              <span class="absolute inset-0 -translate-y-10 left-4 text-[140px] font-bold text-gray-300 opacity-50 select-none leading-none">
                01
              </span>
              <div>
                <div class="relative flex-shrink-0">
                  <div class="relative w-12 h-12 bg-purple-700 rounded-full flex items-center justify-center">
                    <Phone class="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 class="relative text-xl font-bold mt-2 mb-2">{{ steps[0].title }}</h3>
                <p class="relative text-gray-600">
                  {{ steps[0].text }}
                </p>
              </div>
            </div>
  
            <!-- Step 2 -->
            <div class="max-w-[300px] relative">
              <span class="absolute inset-0 -translate-y-10 left-4 text-[140px] font-bold text-gray-300 opacity-50 select-none leading-none">
                02
              </span>
              <div>
                <div class="relative flex-shrink-0">
                  <div class="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center">
                    <LightbulbIcon class="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 class="relative text-xl font-bold mt-2 mb-2">{{ steps[1].title }}</h3>
                <p class="relative text-gray-600">{{ steps[1].text }}</p>
              </div>
            </div>
  
            <!-- Step 3 -->
            <div class="max-w-[300px] relative">
              <span class="absolute inset-0 -translate-y-10 left-4 text-[140px] font-bold text-gray-300 opacity-50 select-none leading-none">
                03
              </span>
              <div>
                <div class="relative flex-shrink-0">
                  <div class="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <PlayIcon class="w-6 h-6 text-white" />
                  </div>
                </div>
                <h3 class="relative text-xl font-bold mt-2 mb-2">{{ steps[2].title }}</h3>
                <p class="relative text-gray-600">{{ steps[2].title }}</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <FormSection />
        </div>
      </div>
    </div>
  </section>
</template>